import { Timestamp } from "firebase/firestore";
import { TagCountInfo } from "./TagCountInfo";

export const VCDirectoryMetadataCollection = "vc-directory-metadata";

export type VCDirectoryMetadata = {
  id: string;
  // Searchable fields:
  stageFocus: string[];
  sectorFocus: string[];
  // Weighted searchable fields:
  stageFocusWeighted: TagCountInfo[];
  sectorFocusWeighted: TagCountInfo[];
  // Counts:
  totalInvestors: number;
  totalInvestorsWithEmail: number;
  totalInvestorsWithPhone: number;
  totalInvestorsWithLinkedIn: number;
  totalInvestorsWithTwitter: number;
  totalInvestorsWithCrunchbase: number;
  createdAt: Timestamp;
};

export function mapDocToVCDirectoryMetadata(
  id: string,
  data: any,
): VCDirectoryMetadata {
  return {
    id,
    stageFocus: data.stageFocus,
    sectorFocus: data.sectorFocus,
    stageFocusWeighted: data.stageFocusWeighted,
    sectorFocusWeighted: data.sectorFocusWeighted,
    totalInvestors: data.totalInvestors,
    totalInvestorsWithEmail: data.totalInvestorsWithEmail,
    totalInvestorsWithPhone: data.totalInvestorsWithPhone,
    totalInvestorsWithLinkedIn: data.totalInvestorsWithLinkedIn,
    totalInvestorsWithTwitter: data.totalInvestorsWithTwitter,
    totalInvestorsWithCrunchbase: data.totalInvestorsWithCrunchbase,
    createdAt: data.createdAt,
  };
}
